import React, { useState } from 'react';
import { Link } from 'gatsby';

import ExternalLinkIcon from '~components/common/ExternalLinkIcon';
import { stateEnums } from '~utils/enums';

import { CustomizableButton } from '~components/common/Button';
import { SelectStandalone } from '~components/forms/inputs/Select';
import { miniToolProps } from '../propTypes';

export default function BallotTracker({ stateInfos }) {
  const [selectedState, setSelectedState] = useState('');

  const selectedStateCode =
    selectedState &&
    stateEnums.find(
      (e) => e.option.toLowerCase() === selectedState.toLowerCase()
    ).value;

  // reprocess stateInfos into a simpler map to deal with
  const stateData = {};
  stateInfos.forEach((state) => {
    const stateName = state.fieldValue;
    const ballotTracker = state.nodes.find(
      (node) => node.field_type === 'gov_tool_provisional_tracker'
    );

    stateData[stateName] = ballotTracker?.text;
  });

  const selectedStateURL = selectedState && stateData[selectedState];

  const handleChange = (evt) => {
    setSelectedState(evt.target.value);
  };

  const handleClick = (evt) => {
    if (!selectedStateURL) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };

  function noStatewideTracker() {
    return (
      <p>
        {selectedState} does not have a ballot tracker. You can{' '}
        <Link
          to={`/local-election-offices/${selectedStateCode}/`}
          title='local election office'
        >
          contact your local election office
        </Link>{' '}
        directly to ask about the status of your ballot.
      </p>
    );
  }

  return (
    <div className='mb-14'>
      <p>
        If you had to cast a provisional ballot on election day (rather than a
        normal ballot), you can use these tools to track that ballot and whether
        it was accepted. If your state doesn&apos;t have a tracker, you can call
        your{' '}
        <Link to='/local-election-offices/' title='local election office'>
          local election office
        </Link>{' '}
        directly.
      </p>
      <p>
        If you cast a normal ballot on election day,{' '}
        <strong>you do not need to use this tool.</strong> Regular in-person
        ballots are counted right away. If you cast a mail-in ballot (also
        called an absentee ballot), you can track it with your state&apos;s{' '}
        <Link to='/ballot-tracker/' title='Mail-In Ballot Tracker'>
          mail-in ballot tracker
        </Link>
        .
      </p>
      <div className='flex max-w-xl flex-row gap-5'>
        <div className='flex-1'>
          <SelectStandalone
            name='state'
            elementId='state'
            onChange={handleChange}
            value={selectedState}
          >
            <option value='' disabled defaultValue>
              Select a state
            </option>
            {Object.keys(stateData).map((stateName) => (
              <option key={stateName} value={stateName}>
                {stateName}
              </option>
            ))}
          </SelectStandalone>
        </div>
        <div className='w-32'>
          <CustomizableButton
            href={selectedStateURL || '#'}
            onClick={handleClick}
            disabled={!selectedStateURL}
            target='_blank'
            rel='noopener'
            elementType='a'
            supplementalStyling='h-12 min-h-0'
          >
            <span>
              Go <ExternalLinkIcon />
            </span>
          </CustomizableButton>
        </div>
      </div>
      <div className='pt-5'>
        {selectedState && !selectedStateURL && noStatewideTracker()}
      </div>
    </div>
  );
}

BallotTracker.propTypes = miniToolProps;
